export default "__VITE_ASSET__5613d974__"